import { isNativeApp } from './platform';

const APP_BG = '#070A12';

/** Reset iOS WKWebView zoom after dismissing the keyboard (font-size 16px is the primary fix). */
function initIosInputZoomGuard() {
  if (typeof window === 'undefined') return;
  const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (!isIos) return;
  const reset = () => {
    window.requestAnimationFrame(() => {
      const viewport = document.querySelector('meta[name="viewport"]');
      if (!viewport) return;
      const content = viewport.getAttribute('content') ?? '';
      if (!content.includes('initial-scale=1')) return;
      viewport.setAttribute('content', `${content}, maximum-scale=1`);
      window.requestAnimationFrame(() => viewport.setAttribute('content', content));
    });
  };
  document.addEventListener('focusout', (e) => {
    const t = e.target;
    if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement || t instanceof HTMLSelectElement) {
      reset();
    }
  });
}

export async function initNativeShell(): Promise<void> {
  initIosInputZoomGuard();

  if (!isNativeApp()) return;

  document.documentElement.classList.add('native-app');
  document.body.classList.add('native-app');
  document.documentElement.style.backgroundColor = APP_BG;
  document.body.style.backgroundColor = APP_BG;

  try {
    const [{ StatusBar, Style }, { SplashScreen }] = await Promise.all([
      import('@capacitor/status-bar'),
      import('@capacitor/splash-screen'),
    ]);
    // Edge-to-edge webview; safe areas handled in CSS via env(safe-area-inset-*)
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.setStyle({ style: Style.Dark });
    await SplashScreen.hide();
  } catch {
    /* non-fatal on simulators */
  }
}
